// List of Files I think can be deleted
// 1. gargolye/libman.json => lib manager file with no libs in it
// 2. gargolye/global.js => bunch of functions that are no longer being used
// 3.

// Dev Rules
// snake_case for variables
// camelCase for functions
// PascalCase for classes

// we are going to switch to tabs so each dev can adjust tab width
